module.exports = __webpack_public_path__ + "img/bacheca_on.3e1f2d4a.svg";